import styled from "styled-components";

const P = styled.p`
`;
export default P;
